export default __webpack_public_path__ + "static/media/q10_step4.d978eef1.png";